import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'

export interface SignedContractsReportRow {
  id: number
  contractNumber: string | null
  contractDate: string | null
  clientNames: string[]
  isBillPaid: boolean | null
  contractSentDate: string | null
  contractTrackingNumber: string | null
  isContractReturnedByClient: boolean | null
}

interface SignedContractsReportTableProps {
  data: SignedContractsReportRow[] | null | undefined
}

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}))

const YesNoLabel = ({ value }: { value: boolean | null }) => {
  if (value === null || value === undefined) return <>—</>
  return <span style={{ color: value ? 'green' : 'red' }}>{value ? 'Да' : 'Нет'}</span>
}

export default function SignedContractsReportTable({
  data
}: SignedContractsReportTableProps) {
  return (
    <TableContainer
      component={Paper}
      sx={{ border: '1px solid #e6e6e6', boxShadow: 0 }}
    >
      <Table sx={{ minWidth: 650 }} aria-label="signed contracts report table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 600 }} align="center">
              № договора
            </TableCell>
            <TableCell sx={{ fontWeight: 600 }} align="center">
              Дата заключения
            </TableCell>
            <TableCell sx={{ fontWeight: 600 }} align="center">
              Контрагент
            </TableCell>
            <TableCell sx={{ fontWeight: 600 }} align="center">
              Счёт оплачен
            </TableCell>
            <TableCell sx={{ fontWeight: 600 }} align="center">
              Дата отправки контрагенту
            </TableCell>
            <TableCell sx={{ fontWeight: 600 }} align="center">
              ШПИ отправления
            </TableCell>
            <TableCell sx={{ fontWeight: 600 }} align="center">
              Договор возвращён контрагентом
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data && data.length > 0 &&
            data.map((row) => (
              <StyledTableRow key={row.id}>
                <TableCell align="center">
                  <Link to={`/service-page/${row.id}`}>
                    {row.contractNumber || '—'}
                  </Link>
                </TableCell>
                <TableCell align="center">
                  {row.contractDate
                    ? dayjs(row.contractDate).format('DD.MM.YYYY')
                    : '—'}
                </TableCell>
                <TableCell align="center">
                  {row.clientNames?.join(', ')}
                </TableCell>
                <TableCell align="center">
                  <YesNoLabel value={row.isBillPaid} />
                </TableCell>
                <TableCell align="center">
                  {row.contractSentDate
                    ? dayjs(row.contractSentDate).format('DD.MM.YYYY')
                    : '—'}
                </TableCell>
                <TableCell align="center">
                  {row.contractTrackingNumber || '—'}
                </TableCell>
                <TableCell align="center">
                  <YesNoLabel value={row.isContractReturnedByClient} />
                </TableCell>
              </StyledTableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
